import { tableFeatures } from '@tanstack/react-table';

/** TanStack features registered on the articles tables. */
export const articlesTableFeatures = tableFeatures({});

export type ArticlesTableFeatures = typeof articlesTableFeatures;
